var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            [
              _c(
                "w-toolbar-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "save" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-container",
        { staticClass: "w100", attrs: { "no-padding": "" } },
        [
          _c(
            "w-breadcrumb",
            { attrs: { crumbs: _vm.path } },
            [
              _c("w-spacer"),
              _vm.$wf.isMdUp
                ? _c(
                    "w-button",
                    {
                      attrs: { disabled: !_vm.canEdit, icon: "save" },
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "w-container",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c(
                        "w-card",
                        [
                          _c("w-card-title", [
                            _vm._v(_vm._s(_vm.$ct("settings"))),
                          ]),
                          _c(
                            "w-card-content",
                            [
                              _c(
                                "w-row",
                                [
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12" } },
                                    [
                                      _c("w-checkbox", {
                                        attrs: {
                                          label: _vm.$ct("use-simple-groups"),
                                        },
                                        model: {
                                          value:
                                            _vm.generalConf.UseSimpleGroups,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.generalConf,
                                              "UseSimpleGroups",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "generalConf.UseSimpleGroups",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.generalConf.UseSimpleGroups,
                      expression: "!generalConf.UseSimpleGroups",
                    },
                  ],
                  attrs: { grow: "", shrink: "" },
                },
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", grow: "", shrink: "" } },
                    [
                      _c(
                        "w-card",
                        { style: { height: "100%" } },
                        [
                          _c("w-card-title", [
                            _vm._v(_vm._s(_vm.$ct("product-groups"))),
                          ]),
                          _c(
                            "w-scroll-view",
                            {
                              staticClass: "content",
                              attrs: { tag: "w-card-content" },
                            },
                            [
                              !_vm.canEdit
                                ? _c(
                                    "div",
                                    { staticClass: "error-message" },
                                    [
                                      _c("w-fa", {
                                        staticClass: "mr",
                                        attrs: { icon: "exclamation-circle" },
                                      }),
                                      _vm._v(
                                        _vm._s(
                                          _vm.$ct("only-admins-can-edit-groups")
                                        )
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c("app-product-groups-edit", {
                                on: {
                                  input: function ($event) {
                                    return _vm.onInput($event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }